import axios from 'axios';
import { getSubdomain } from '../utils/subdomain';
const keyCache = `user`;
const lastMeCallKey = 'lastMeCall';
const ME_CALL_THROTTLE = 2000; // 2 seconds throttle

const API_URL = process.env.REACT_APP_EP_API;

export const authUser = (force = false) => {
  const cachedAuth = localStorage.getItem(keyCache);
  if (cachedAuth && !force)
    return JSON.parse(cachedAuth);

  return updateUser();
};

export const updateUser = () => {
  let currentUser = localStorage.getItem(keyCache);
  if (!currentUser) return null;

  const currentUserJson = JSON.parse(currentUser);
  currentUserJson.fullName = `${currentUserJson.firstName} ${currentUserJson.lastName}`;

  localStorage.setItem(keyCache, JSON.stringify(currentUserJson));

  return currentUserJson;
};


export const purgeCache = () => {
  localStorage.removeItem(keyCache);
  localStorage.removeItem(lastMeCallKey);
};


// Function to perform login
export const apiLogin = async (email, password, company) => {
  try {
    const formData = new URLSearchParams();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('company', company);

    const response = await axios.post(`${API_URL}/auth/login`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-Company-Code': getSubdomain() || 'demo',
      },
    });

    // Handle response

    // Clear throttle to allow immediate /me call after login
    localStorage.removeItem(lastMeCallKey);

    // Cache the authenticated user
    localStorage.setItem(keyCache, JSON.stringify(response.data));

    return response.data;
  } catch (error) {
    // Handle error
    console.error('Login failed:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const validateResetToken = async (token, company, newPassword) => {
  const formData = new FormData();
  formData.append('token', token);
  formData.append('company', company);
  formData.append('newPassword', newPassword);

  try {
    const response = await fetch(`${API_URL}/auth/validate-reset-token`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
      },
      body: formData
    });

    return await response.json();
  } catch (error) {
    throw error;
  }
};


export const checkUpdateMe = async (currentUser) => {
  if (!currentUser || !currentUser.accessToken) {
    console.error('checkUpdateMe - No valid user or accessToken:', {
      hasUser: !!currentUser,
      hasAccessToken: currentUser ? !!currentUser.accessToken : false
    });
    return null;
  }

  // Throttle /me calls to avoid multiple requests in short time
  const now = Date.now();
  const lastCall = localStorage.getItem(lastMeCallKey);

  if (lastCall && (now - parseInt(lastCall)) < ME_CALL_THROTTLE) {
    console.log('Throttling /me call - using cached user from localStorage');
    // Return fresh user from localStorage instead of passed parameter
    const cachedUser = localStorage.getItem(keyCache);
    return cachedUser ? JSON.parse(cachedUser) : currentUser;
  }

  try {
    localStorage.setItem(lastMeCallKey, now.toString());

    console.log('Making /me request with token:', currentUser.accessToken.substring(0, 20) + '...');

    const response = await axios.get(`${API_URL}/me`, {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-Company-Code': getSubdomain() || 'demo',
      },
    });

    console.log('/me request successful');

    const updatedUser = {
      ...response.data,
      accessToken: currentUser.accessToken,
      refreshToken: currentUser.refreshToken
    };

    localStorage.setItem('user', JSON.stringify(updatedUser));
    return updatedUser;
  } catch (error) {
    console.error('Session check failed - Status:', error.response && error.response.status, 'Message:', error.response ? error.response.data : error.message);
    if (error.response && error.response.status === 401) {
      console.error('Got 401 - Logging out');
      purgeCache();
      window.location.href = '/login';
    }
    throw error;
  }
};

// Re-export getSubdomain from utils/subdomain
export { getSubdomain } from '../utils/subdomain';
